// Alertas de tarefas — compartilhado entre Prazos, NotificacoesBell e Sidebar.
// Prazos.js popula ao carregar; componentes lêem via hooks.

import { useState, useEffect } from "react";

let _count   = 0;
let _tarefas = [];
let _countListeners   = new Set();
let _tarefasListeners = new Set();

export function setAlertaCount(count) {
  _count = count;
  _countListeners.forEach(fn => fn(count));
}

export function setAlertaTarefas(list) {
  _tarefas = list;
  _tarefasListeners.forEach(fn => fn(list));
}

export function useAlertaCount() {
  const [val, setVal] = useState(_count);
  useEffect(() => {
    _countListeners.add(setVal);
    return () => _countListeners.delete(setVal);
  }, []);
  return val;
}

export function useAlertaTarefas() {
  const [val, setVal] = useState(_tarefas);
  useEffect(() => {
    _tarefasListeners.add(setVal);
    return () => _tarefasListeners.delete(setVal);
  }, []);
  return val;
}
